module.exports = __webpack_public_path__ + "static/media/gal-13.b4740c9c.jpeg";